import { useState } from 'react';
import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from '../../common/navigation/SideNavigationMenu';
import Paths from "common/paths/paths";
import { useFlashBarItems } from 'common/UseFlashBarItems/useFlashBarItems';
import { Flashbar, SpaceBetween } from '@amzn/awsui-components-react';
import { useOrderEdit } from './useOrderEdit';
import { SinglePageDetailsContainer } from 'components/OrderDetailsContent/SinglePage/SinglePageDetailsContainer';
import { useParams, useNavigate } from 'react-router-dom';
import { getString } from 'common';

interface OrderDetailsSingleViewPageProps {
  isExternalView?: boolean
}

const OrderDetailsSingleViewPage = (props: OrderDetailsSingleViewPageProps) => {
  const flashBarItemsHook = useFlashBarItems();
  const { items, actions } = useOrderEdit(flashBarItemsHook.actions, props.isExternalView);
  const [navigationOpen, setNavigationOpen] = useState(false);

  const breadcrumbs = {
    items:
      [
        { text: Paths.Admin.name, href: Paths.Admin.url },
        { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
        { text: items.orderReference, href: "#" }
      ]
  }

  return (
    <AppLayout
      maxContentWidth={2300}
      stickyNotifications
      content={
        <SpaceBetween direction="vertical" size="m">
          <SinglePageDetailsContainer
            useOrderEditItems={items}
            useOrderEditActions={actions}
            useFlashBarItemsActions={flashBarItemsHook.actions}
          />
        </SpaceBetween>
      }
      contentType="default"
      breadcrumbs={!props.isExternalView && <NavigationBreadcrumbs items={breadcrumbs.items} />}
      navigation={<SideNavigationMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
      navigationHide={props.isExternalView}
      notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems data-testid="notifications-flashbar" />}
      toolsHide={true}
    />
  );
}

export default OrderDetailsSingleViewPage;
